export function joinedLabel(createdAt: number | undefined): string {
  if (!createdAt) return '';
  return new Date(createdAt).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}
